import React from 'react';
import './AdSenseLayout.css';

// AdSense placeholder component
const AdSenseUnit = ({ size, className = '', style = {} }) => {
  return (
    <div className={`adsense-unit ${className}`} style={style}>
      <div className="adsense-placeholder">
        <div className="ad-label">Advertisement</div>
        <div className="ad-size">{size}</div>
        {/* In production, replace this with actual AdSense code */}
        <div className="ad-placeholder-content">
          AdSense Unit ({size})
        </div>
      </div>
    </div>
  );
};

// Layout wrapper with AdSense placements
const AdSenseLayout = ({ children, showSidebar = true }) => {
  return (
    <div className="adsense-layout">
      {/* Top Banner Ad */}
      <div className="ad-container top-banner">
        <AdSenseUnit size="728x90" className="top-banner-ad" />
      </div>

      <div className="content-wrapper">
        {/* Sidebar with ads */}
        {showSidebar && (
          <aside className="sidebar">
            <div className="sidebar-ad">
              <AdSenseUnit size="300x250" className="sidebar-ad-unit" />
            </div>
            <div className="sidebar-ad">
              <AdSenseUnit size="300x600" className="sidebar-ad-unit" />
            </div>
          </aside>
        )}

        {/* Main content area */}
        <main className={`main-content ${!showSidebar ? 'full-width' : ''}`}>
          {children}

          {/* In-content ad */}
          <div className="ad-container in-content">
            <AdSenseUnit size="300x250" className="in-content-ad" />
          </div>
        </main>
      </div>

      {/* Bottom banner ad */}
      <div className="ad-container bottom-banner">
        <AdSenseUnit size="728x90" className="bottom-banner-ad" />
      </div>
    </div>
  );
};

export default AdSenseLayout;
export { AdSenseUnit };
